import { createClient } from "@supabase/supabase-js";

/**
 * Supabase project connection configuration.
 * URL and anon key (public by design) are hardcoded on purpose: every
 * environment uses this one project. DB password is never stored in code.
 */
export const SUPABASE_URL = "https://jxnzdtmqsjekmhxstobh.supabase.co";

export const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp4bnpkdG1xc2pla21oeHN0b2JoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTIzOTY3NTAsImV4cCI6MjEwNzk3Mjc1MH0.w2KGUCQQZF_eD_umRmXKulbMSIdSwBM25cNdw05rWFQ";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
